<template>
  <div>
    <input v-model="user" type="text" />
    <input v-model="message" type="text" /><br />
    <button @click="sendMsg">发送</button>
    <hr />
    <ul>
      <li v-for="(item, index) in msgList" :key="index">
        {{ item.username }}:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.msg }}
      </li>
    </ul>
  </div>
</template>

<script>
const signalR = require("@microsoft/signalr");
import global from "../unit/global";
//import bus from "../unit/bus";
export default {
  data() {
    return {
      connection: "",
      user: "",
      message: "",
      msgList: [],
      charroomip: global.httpid,
      username: "账务部",
    };
  },
  created() {
    this.init();
  },
  mounted() {
    // bus.$on("msg", (val) => {
    //   this.message = val;
    //   this.sendMsg();
    // });
  },
  methods: {
    init() {
      // this.connection = new signalR.HubConnectionBuilder()
      //   .withUrl("http://localhost:5001/chathub", {})
      //   .configureLogging(signalR.LogLevel.Error)
      //   .build();

      this.connection = new signalR.HubConnectionBuilder()
        .configureLogging(signalR.LogLevel.Information)
        .withUrl(`${this.charroomip}chathub?username=${this.username}`, {
          accessTokenFactory: () => localStorage.getItem("accessToken"),
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: () => {
            //每5秒重连一次
            return 5000;
          },
        }) //自动重连
        .build();
      this.connection.on("ReceiveMessage", (data) => {
        this.msgList.push(data);
      });
      this.connection.start();
    },
    sendMsg() {
      let params = {
        Username: this.user,
        msg: this.message,
        group: localStorage.getItem("accessToken"),
      };
      this.connection.invoke("SenlGroupMsg", params);
    },
  },
};
</script>

<style>
</style>

